import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { ApprovedStatusType } from '@/models/reservation-approved-status'

type ApprovedStatusCellProps = {
  status: ApprovedStatusType
}

export const ApprovedStatusCell: React.FC<ApprovedStatusCellProps> = ({ status }) => {
  const { t } = useTranslation()

  /**
   * ステータスに対応する背景色マッピング
   */
  const statusColor: Record<ApprovedStatusType, string> = {
    [ApprovedStatusType.Reservation]: '#F2A40B',
    [ApprovedStatusType.Checkin]: '#F47110',
    [ApprovedStatusType.Stay]: '#3E85CC',
    [ApprovedStatusType.Checkout]: '#7DC931',
    [ApprovedStatusType.Customer]: '#999999',
  }

  /**
   * ステータスに対応するテキストラベルのMap
   */
  const statusText: Record<ApprovedStatusType, string> = {
    [ApprovedStatusType.Reservation]: t('Reserve'),
    [ApprovedStatusType.Checkin]: t('Checkin'),
    [ApprovedStatusType.Stay]: t('During your stay'),
    [ApprovedStatusType.Checkout]: t('Checkout'),
    [ApprovedStatusType.Customer]: t('Customer'),
  }

  return (
    <div css={approvedStatusStyle} style={{ backgroundColor: statusColor[status] }} className="approved-status-col">
      {statusText[status] ?? '-'}
    </div>
  )
}

const approvedStatusStyle = css({
  width: 116,
  height: 26,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  borderRadius: 5,
  border: '1px solid #fff',
  paddingRight: 6,
  fontSize: 12,
  fontWeight: 'bold',
  letterSpacing: 0,
  color: '#fff',
})
